<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="{
        backgroundImage: 'url(' + header_pictures.news_header_picture.url + ')',
      }"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="news-section">
          <div class="navigation-breadcrumbs">
            <router-link to="/">
                <h5>Asiongs</h5>
            </router-link>  
            <h5>></h5>
            <router-link to="/news">
                <h5>News</h5>
            </router-link> 
            <h5>></h5>
            <h5>{{news.title}}</h5>
          </div>
          <Loader v-if="loading" />
          <div class="news-post-individual" v-else>
            <div class="news-post-image">
                <img :src=news.main_picture.url>
            </div>
            <h3 class="title">{{news.title}}</h3>
            <small >{{news.published_at}}</small>
            <vue-simple-markdown :source=news.body></vue-simple-markdown>
          </div>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader.vue";
import Faqcordion from "@/components/Faqcordion.vue";

export default {
  components: {
    Loader,
  },
  name: "Newspost",
  bodyClass: "profile-page",
  data() {
    return {
      newsid: this.$route.params.newsid,
      news: {
        main_picture: {
          url: ''
        }
      },
      newsarray: [],
      loading: true,
      more_news: [],
    };
  },
  props: {
    header_pictures: Object
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/news-posts?slug=" + this.newsid, {}).then(
        (response) => {
            this.newsarray = response.data;
            this.news = this.newsarray[0];
            this.loading = false;
        },
        (error) => {
            // console.log(error);
        }
    );
  },
  computed: {

  },
  metaInfo() {
    return{
      title: this.news.title,
      meta: [
        { name: 'description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:title', content: "Asiong's Industrial Products"},
        { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:site_name', content: 'Asiongs Industrial Products'},
        { property: 'og:type', content: 'website'},    
        { property: 'og:image', content: this.news.main_picture.url}
      ]
    }
  }
};
</script>

<style lang="scss" scoped>

.section {
  padding: auto;
  overflow: hidden;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.news-section{
    max-width: 1440px;
    margin: auto;
    padding: 32px;

    .news-post{
        margin-bottom: 32px;

        img{
            height: 100%;
            object-fit: cover;
        }

        .news-post-texts{
            padding: 32px;
            border: 1px solid #eeeeee;

            h3{
                transition: 0.2s;
                &:hover{
                    color: #182e5a;
                    text-decoration: underline;
                }
            }
        }
    }
    
    
    @media only screen and (min-width: 992px) {
        .news-post{
            display: grid;
             grid-template-columns: repeat(auto-fit, minmax(440px , 1fr));;
        }
    }

    @media only screen and (max-width: 991px) {
    
    }

    
}
.navigation-breadcrumbs{
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  
  h5{
    margin: 0px 4px;
  }

}



</style>
